"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useTrigger = function useTrigger(initialTrigger, triggerProps, tag) {
  if (tag === void 0) {
    tag = 'span';
  }

  if (!initialTrigger) return {};
  var trigger = /*#__PURE__*/_react.default.isValidElement(initialTrigger) ? /*#__PURE__*/_react.default.cloneElement(initialTrigger, _extends({
    tabIndex: tag === 'button' ? undefined : 0
  }, triggerProps), initialTrigger.props.children) : /*#__PURE__*/_react.default.createElement(tag, _extends({
    tabIndex: tag === 'button' ? undefined : 0
  }, triggerProps), initialTrigger);
  return {
    trigger: trigger
  };
};

var _default = useTrigger;
exports.default = _default;